import React from "react";
import { Row, Col, FullRow } from "../framework/Grid/";
import AcquireWebComponent from "../framework/MaterialUI";
import MySettingsNavigator from "./navigator";
import { isUndefined, isNil, isEmpty, find } from "lodash";
import Select from "react-select";

import "./mysettings.css";
import SiteDateSelector from "../Insights/SiteDateSelector";
import WebTagsTable from "../Insights/tags/WebTagsTable";
import EmailTagsTable from "../Insights/tags/EmailTagsTable";
import EmailTagDetail from "../Insights/tags/EmailTagDetail";
import HtmlTagDetail from "../Insights/tags/HtmlTagDetail";
import TagCreation from "../Insights/tags/TagCreation";
import { getUrlParameterByName } from "../../utils/utility";

class MySettings extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      clientName: "",
      buName: "",
      clientId: undefined,
      tag_type: "Web",
      filter_tag_type: "Web",
    };
    const cid = getUrlParameterByName("cid");
    if (cid && parseInt(cid, 10) > 1) {
      this.props.selectClient(parseInt(cid, 10));
      this.props.getClientSites(parseInt(cid, 10));
      this.props.getClientTags(parseInt(cid, 10));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected_client !== this.props.selected_client) {
      if (parseInt(nextProps.selected_client, 10) > 1) {
        this.props.getClientSites(nextProps.selected_client);
        this.props.getClientTags(nextProps.selected_client);
        this.props.history.push(
          "/settings/tags/list?cid=" + nextProps.selected_client,
        );
      }
    }
    //if ((nextProps.tag_info) && (isUndefined(this.props.tag_info))) {
    if (nextProps.client_info !== this.props.client_info) {
      let clientName = nextProps.client_info ? nextProps.client_info.name : "";
      let buName = "";
      if (nextProps.client_info && nextProps.client_info.parentClientId) {
        buName = nextProps.client_info.name;
        const c = find(this.props.clients, function(c) {
          return c.id === nextProps.client_info.parentClientId;
        });
        clientName = c ? c.name : "";
      }
      this.setState({
        clientName: clientName,
        buName: buName,
      });
    }
  }

  componentDidMount() {
    this.props.clearInsightTagInfo();
    this.props.clearTagError();
    if (this.props.selected_client && this.props.selected_client > 1) {
      //if (this.props.clients.length === 0) {
      this.props.getClientSites(this.props.selected_client);
      //}
      this.props.getClientTags(this.props.selected_client);
    } else {
      if (
        this.props.selected_client &&
        String(this.props.selected_client).indexOf("r-") >= 0
      ) {
        if (this.props.clients.length > 0) {
          if (this.props.clients[0].id === 1 && this.props.clients.length > 1) {
            this.props.selectClient(this.props.clients[1].id);
          } else {
            if (this.props.clients[0].id !== 1) {
              this.props.selectClient(this.props.clients[0].id);
            } else {
              window.location = "/";
            }
          }
        }
      }
    }
  }

  backToListClick(e) {
    e.preventDefault();
    const { client_info } = this.props;
    this.props.clearInsightTagInfoAndRefreh(client_info.id);
  }

  clickCreateTag(e) {
    e.preventDefault();
    this.props.createNewTag();
  }

  tagDetailContent(type) {
    return (
      <HtmlTagDetail
        type={type}
        clientName={this.state.clientName}
        buName={this.state.buName}
        imgTagName={this.state.imgTagName}
        backToListClick={this.backToListClick.bind(this)}
        style={{ padding: "0 20px" }}
        {...this.props}
      />
    );
  }

  handleFilterTagTypeChanged(e) {
    this.setState({
      filter_tag_type: e.value,
    });
  }

  getContent() {
    const {
      match,
      clients,
      client_info,
      tag_info,
      websiteId,
      client_sites,
    } = this.props;
    const siteId = websiteId
      ? websiteId
      : client_sites && client_sites.length > 0
      ? client_sites[0].value
      : null;
    const tagDevOptions = [
      { value: "Web", label: "Web Property" },
      {
        value: "Email",
        label: "HTML Email",
      } /*,
			{ value: 'Mobile', label: 'Year to date' }*/,
    ];
    const showCreateTagBtn = this.props.roleId < 53 && this.props.roleId !== 5;
    switch (match.params.action) {
      case "detail":
        if (!isUndefined(tag_info)) {
          if (tag_info.deploymentType === "Web")
            return this.tagDetailContent("detail");
          else
            return (
              <EmailTagDetail
                clientName={this.state.clientName}
                style={{ padding: "0 20px" }}
                buName={this.state.buName}
                type={"detail"}
                backToListClick={this.backToListClick.bind(this)}
                {...this.props}
              />
            );
        }
        this.props.history.push("/settings/tags/list");
        break;
      case "create":
        let clientName = client_info ? client_info.name : "";
        let buName = "";
        if (client_info && client_info.parentClientId) {
          buName = client_info.name;
          const c = find(clients, c => {
            return c.id === client_info.parentClientId;
          });
          clientName = c ? c.name : "";
        }
        if (isNil(tag_info)) {
          return (
            <TagCreation
              clientName={clientName}
              buName={buName}
              tagDevOptions={tagDevOptions}
              tag_variables={[]}
              style={{ padding: "0 20%" }}
              tag_vars_deploy={"unique"}
              pass_variables={[]}
              hash_format={[]}
              hash_case={"upper"}
              {...this.props}
            />
          );
        } else {
          if (tag_info.deploymentType === "Web")
            return this.tagDetailContent("create");
          else
            return (
              <EmailTagDetail
                clientName={this.state.clientName}
                backToListClick={this.backToListClick.bind(this)}
                buName={this.state.buName}
                type={"create"}
                style={{ padding: "0 20px" }}
                {...this.props}
              />
            );
        }
      case "edit":
        clientName = client_info ? client_info.name : "";
        buName = "";
        if (client_info && client_info.parentClientId) {
          buName = client_info.name;
          const c = find(clients, c => {
            return c.id === client_info.parentClientId;
          });
          clientName = c ? c.name : "";
        }
        if (this.props.tag_info) {
          const {
            tagParams,
            dynamic,
            campaignName,
            deploymentType,
            siteName,
            domain,
            id,
          } = this.props.tag_info;
          const {
            website_name,
            website_url,
            campaign_name,
            hash_case,
            tag_variables,
            tag_info,
            ...rest
          } = this.props;
          return (
            <TagCreation
              clientName={clientName}
              buName={buName}
              tag_type={deploymentType}
              website_name={siteName}
              website_url={domain}
              id={id}
              campaign_name={campaignName}
              tagDevOptions={tagDevOptions}
              style={{ padding: "0 20%" }}
              tag_variables={tagParams ? tagParams.pageReferences : []}
              tag_vars_deploy={dynamic ? "dynamic" : "unique"}
              pass_variables={tagParams ? tagParams.passThroughs : []}
              hash_format={tagParams ? tagParams.hashedEmails : []}
              hash_case={tagParams && tagParams.upperCase ? "upper" : "lower"}
              {...rest}
            />
          );
        }
        this.props.history.push("/settings/tags/list");
        break;
      default:
        return (
          <div className="mysettings-tag-content">
            <Row className="no-padding mb-20 no-margin-top text-right">
              <Col xs="12" sm="12" md="12" lg="12" className="text-right">
                {showCreateTagBtn && (
                  <button
                    type="button"
                    className="btn btn-default legitRipple btn-aa-default"
                  >
                    <a
                      onClick={e => {
                        this.clickCreateTag(e);
                      }}
                    >
                      GENERATE INSIGHTS TAG
                    </a>
                  </button>
                )}
              </Col>
            </Row>
            {isEmpty(this.props.client_tags) ? (
              <div
                className="black-border pb-10 text-center"
                style={{ minHeight: "200px", paddingTop: "80px" }}
              >
                <div
                  style={{ color: "#000", fontSize: "11pt", opacity: "0.8" }}
                >
                  No tags currently available.
                </div>
              </div>
            ) : (
              <div
                className="black-border pb-20 pl-20 pr-20"
                style={{ background: "#fff", minHeight: "200px" }}
              >
                <h3
                  className="mt-20"
                  style={{ fontSize: "16px", fontWeight: "bold" }}
                >
                  TAGS
                </h3>
                <FullRow className="no-padding mb-20">
                  <span
                    style={{
                      fontWeight: "bold",
                      position: "absolute",
                      top: "10px",
                    }}
                  >
                    Tag Deployment Type
                  </span>
                  <span style={{ width: "180px", display: "inline-block" }}>
                    &nbsp;
                  </span>
                  <Select
                    value={this.state.filter_tag_type}
                    name=""
                    className="tag-dev-type-selection"
                    clearable={false}
                    options={tagDevOptions}
                    searchable={false}
                    onChange={this.handleFilterTagTypeChanged.bind(this)}
                  />
                </FullRow>
                {this.state.filter_tag_type === "Web" ? (
                  <WebTagsTable
                    client_tags={this.props.client_tags}
                    getTagDetail={this.props.getTagDetail}
                    client_info={this.props.client_info}
                    redirectUrl={"/settings/tags/detail"}
                  />
                ) : (
                  <EmailTagsTable
                    client_tags={this.props.client_tags}
                    getTagDetail={this.props.getTagDetail}
                    client_info={this.props.client_info}
                    redirectUrl={"/settings/tags/detail"}
                  />
                )}
              </div>
            )}
          </div>
        );
    }
  }

  render() {
    const { websiteId, client_sites, match } = this.props;
    const siteId = websiteId
      ? websiteId
      : client_sites && client_sites.length > 0
      ? client_sites[0].value
      : null;
    return (
      <div id="mysettings-container">
        {["list", "detail", "edit", "create"].indexOf(match.params.action) <
          0 && (
          <div style={{ padding: "10px 10%", fontSize: "16px" }}>
            <SiteDateSelector
              type={"larger"}
              websiteIdChanged={this.props.setWebsiteId}
              siteId={siteId}
              sites={client_sites}
              style={{
                paddingTop: "0px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            />
          </div>
        )}
        <div style={{ display: "flex", padding: "10px 10%", fontSize: "16px" }}>
          <MySettingsNavigator
            activeIndex={0}
            history={this.props.history}
            client={this.props.client_info}
            selected_client={this.props.selected_client}
          />
          <div className="mysettings-content">{this.getContent()}</div>
        </div>
      </div>
    );
  }
}

export default MySettings;



// WEBPACK FOOTER //
// ./src/components/MySettings/index.jsx